import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { Grid as GridComponent } from '@elfsight/lib-masonry-grid';
import { useSettings } from '@wu/widget-core';
import { noop } from 'es-toolkit';
import type { Job } from '../../../types';
import { Item } from '../items';
import { LayoutContainer } from '../LayoutContainer';

type ListProps = HTMLAttributes<HTMLDivElement> & {
  jobs: Job[];
};

export const List = forwardRef<HTMLDivElement, ListProps>(
  ({ jobs, ...forwardingProps }, ref) => {
    const { listLayoutGap: gap } = useSettings();

    return (
      <LayoutContainer gap={gap} ref={ref} {...forwardingProps}>
        <GridComponent
          className="Grid__Container-sc"
          onEffectiveColumnsChange={noop}
          columns={1}
          gap={[0, gap]}
        >
          {jobs.map((item) => (
            <Item data={item} key={item.id} />
          ))}
        </GridComponent>
      </LayoutContainer>
    );
  }
);
